export enum CompanyDetailSectionEnum {
  General = 'general',
  Users = 'users',
  MessagingConversations = 'messaging-conversations',
  Communications = 'communications',
  Locations = 'locations',
}

export const CompanyDetailSectionEnumLabels: Record<CompanyDetailSectionEnum, string> = {
  [CompanyDetailSectionEnum.General]: 'Datos generales',
  [CompanyDetailSectionEnum.Users]: 'Usuarios',
  [CompanyDetailSectionEnum.MessagingConversations]: 'Conversaciones',
  [CompanyDetailSectionEnum.Communications]: 'Comunicaciones',
  [CompanyDetailSectionEnum.Locations]: 'Ubicaciones',
};
